/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "./Text";
import T from "./Translation";
import { useConfig } from "../../lib/react-query/useConfig";

const RecordCard = styled.div`
  display: grid;
  gap: 1.5rem;
  padding-block: 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
`;

const RecordCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-inline: 1rem;

  ${({ theme }) => theme.containerMedia.sm} {
    flex-direction: column;
    gap: 1rem;
  }
`;

const RecordCardHeaderCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || "0.5rem"};

  ${({ $align }) =>
    $align === "right" &&
    css`
      align-items: flex-end;
      text-align: right;
    `}

  ${({ theme }) => theme.containerMedia.sm} {
    gap: ${({ $gap }) => $gap || "0.25rem"};
    align-items: start;
    text-align: left;
  }
`;

const RecordCardHeaderColItem = styled.div`
  display: flex;
  align-items: center;

  & > *:first-child::after {
    content: ":";
    margin-right: 0.25rem;
  }
`;

const StyledTimezoneNote = styled((props) => <Text {...props} />)`
  margin-top: 0.5rem !important;
  padding-left: 1rem;
`;

// "All dates and times are in company timezone" disclaimer, shared by InvoiceCard
// and ClientRecurringProfile.
const TimezoneNote = () => {
  const { data: config } = useConfig();

  return (
    <StyledTimezoneNote size="tiny" color="dark">
      *<T timezone={config.timezone}>all_dates_and_times_in_company_timezone_%timezone%</T>
    </StyledTimezoneNote>
  );
};

export { RecordCard, RecordCardHeader, RecordCardHeaderCol, RecordCardHeaderColItem, TimezoneNote };
